import { PropertyDataHome } from './components/PropertyDataHome';

export const StepTwo = () => <PropertyDataHome />;
